import * as React from 'react';

import { Box, Button, Typography, Stack, useTheme, FormControlLabel, Checkbox } from '@mui/material';
import { useAuth } from '@dwelvio/auth-react';

import { useNavigate, useSearchParams } from 'react-router';
import { SignUpForm } from './components/signup-form';
import { appPaths } from '../../app-paths';
import { IUserData } from '../../types';
import { LogoWithText } from '../../components/logo-with-text';
import { useAlert } from '@dwelvio/react-alert';

export function SignUpPage() {
  const { signup, error } = useAuth<IUserData>();
  const navigate = useNavigate();
  const { show } = useAlert();
  const theme = useTheme();
  const [params] = useSearchParams();
  const [acceptedPrivacy, setAcceptedPrivacy] = React.useState(false);
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);

  const refUrl = params.get('refUrl') || undefined;

  return (
    <Box
      maxWidth="400px"
      minWidth="300px"
      sx={{ mx: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      <Box
        component="header"
        sx={{ mx: 'auto', py: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <LogoWithText color={theme.palette.primary.main} textColor={theme.palette.secondary.dark} height={50} />
      </Box>
      <Box component="main" sx={{ mx: 'auto', py: 3, px: 2 }}>
        <Stack gap={4} sx={{ mb: 2 }}>
          <Typography variant="h4">Registrácia</Typography>
          <Stack spacing={0}>
            <Typography variant="body2">Registráciou súhlasíte so</Typography>
            <FormControlLabel
              control={<Checkbox name="privacy" size="small" onClick={() => setAcceptedPrivacy(!acceptedPrivacy)} />}
              label={
                <Typography variant="body2">
                  <a href={appPaths.privacy()}>Zásadami ochrany osobných údajov</a>
                </Typography>
              }
            />
            <FormControlLabel
              control={<Checkbox name="terms" size="small" onClick={() => setAcceptedTerms(!acceptedTerms)} />}
              label={
                <Typography variant="body2">
                  <a href={appPaths.terms()}>Podmienkami používania</a>
                </Typography>
              }
            />
          </Stack>

          {/* <Button
            fullWidth
            variant="contained"
            startIcon={<GoogleIcon />}
            disabled={!acceptedPrivacy || !acceptedTerms}
          >
            Registrácia cez Google
          </Button> */}
        </Stack>
        {/* <Divider>alebo</Divider> */}
        <Stack gap={1} sx={{ mt: 2 }}>
          <SignUpForm
            disabledSubmit={!acceptedPrivacy || !acceptedTerms}
            onSubmit={async (username: string, password: string) => {
              const signupResult = await signup(username, password);
              if (signupResult === 'success') {
                navigate(appPaths.verifyEmail.navigate() + `?email=${encodeURIComponent(username)}`);
              } else {
                show.error('Registrácia sa nepodarila. Skontrolujte, prosím, svoje údaje.', signupResult);
              }
            }}
          />
          <Typography variant="body2" textAlign="center">
            Už máte účet?{' '}
            <Button variant="text" onClick={() => navigate(appPaths.signin.navigate({ refUrl }))}>
              Prihláste sa
            </Button>
          </Typography>
        </Stack>
      </Box>
      <Box component="footer" sx={{ py: 3 }}>
        <Typography variant="body2" textAlign="center">
          © dwelvio.com {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
}
